/**
 * wrappes a Promise and rejects if timeout is over
 *
 * @param {number} ms timout in miliseconds
 * @param {Promise} promise the promise to wrap
 * @returns {Promise} the wrapped promise
 */
export function timeoutPromise(ms, promise) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(Error("promise timeout"));
    }, ms);
    promise.then(resolve, reject);
  });
}
